const FromArr = [{
		modelvalue: '',
		title: "授权经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "订货经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '0',
		title: "是否授权书生成：",
		inputtype: "checkebox",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "创建时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "创建时间",
		heightLeft: 32,
		heightRight: 32,
		widthLeft: 150,
		widthRight: 150,
		disabled: false,
		marginLeft: 10,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		modelvalue: '',
		title: "医院：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
];
export default FromArr;